<template>
  <div class="container">
    <div class="c-top">
      <img class="r-top" src="../../assets/img/arrow.png" @click="onClickAdjust('top')" />
    </div>
    <div class="c-body">
      <div style="flex: 1">
        <img class="r-left" src="../../assets/img/arrow.png" @click="onClickAdjust('left')" />
      </div>
      <div style="flex: 1; text-align: right">
        <img class="r-right" src="../../assets/img/arrow.png" @click="onClickAdjust('right')" />
      </div>
    </div>
    <div class="c-bottom">
      <img @click="onClickAdjust('down')" class="r-down" src="../../assets/img/arrow.png" />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onClickAdjust(driction) {
      this.$emit('onClickAdjust', driction);
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 90px;
  height: 90px;
  img {
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
}
.c-top {
  display: flex;
  justify-content: center;
}
.c-body {
  height: 30px;
  display: flex;
  justify-content: center;
}

.c-bottom {
  display: flex;
  justify-content: center;
}
.r-top {
  transform: rotate(-90deg);
}
.r-down {
  transform: rotate(90deg);
}

.r-left {
  transform: rotate(180deg);
}
</style>